<template>
  <div class="poster">
    <div class="content" id="poster-2">
      <img
        class="image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7c0a4f58ac5787adbd86fbaba7b48648.png"
        alt=""
      />
      <!--   <div class="day">{{ data.headerDatum.day }}天</div> -->
      <div class="time">{{ data.headerDatum.time | timeLineToDot }}</div>
      <div class="camp-info">
        <div class="camp-name">{{ data.headerDatum.alias }}</div>
        <div class="nickname">{{ data.user.truename }}同学</div>
      </div>
      <div class="lose-weight">{{
        (data.infoDatum.weight * 2) | filterBodyInfo
      }}</div>
      <div class="win-cash">{{ data.win_cash || 0 }}元现金</div>
      <img
        class="qrcode"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c48d2927e3317a052bb26949446b8db4.jpg"
        alt=""
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  filters: {
    timeLineToDot(val) {
      val = val.replace(/--/g, '#')
      val = val.replace(/-/g, '.')
      val = val.replace(/#/g, '-')
      return val
    },
    filterBodyInfo(value) {
      if (value > 0) {
        return '+' + value
      } else if (value == 0) {
        return '-0'
      } else {
        return value
      }
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.poster {
  position: fixed;
  left: 200%;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-color: rgba(0, 0, 0, 0.6);

  .content {
    position: relative;
    width: 100%;
    height: 500px;
    overflow: hidden;

    .image {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
      object-fit: contain;
    }

    .day {
      position: absolute;
      left: 285px;
      top: 117px;
      font-size: 12px;
      font-style: italic;
      font-family: Source-KeynoteartHans-Regular, Source-KeynoteartHans;
      color: #ffeee5;
      line-height: 14px;
      padding: 2px 4px;
      font-weight: 600;
      background: linear-gradient(157deg, #654369 0%, #352038 100%);
      border-radius: 5px 5px 5px 0px;
    }

    .time {
      position: absolute;
      font-size: 11px;
      font-family: MiSans, MiSans;
      font-weight: 600;
      color: #e2e2e4;
      line-height: 15px;
      width: 130px;
      box-sizing: border-box;
      text-align: center;
      top: 251px;
      left: 128px;
    }

    .camp-info {
      position: absolute;
      left: 8px;
      top: 14px;
    }

    .camp-name {
      font-size: 17px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.8);
      line-height: 24px;
    }

    .nickname {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 25px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      line-height: 25px;
      color: rgba(0, 0, 0, 0.8);
    }

    .lose-weight {
      width: 100px;
      position: absolute;
      left: 31px;
      top: 310px;
      font-weight: 600;
      font-size: 29px;
      text-align: center;
      font-family: GothamBlack;
      color: #fffdf8;
      line-height: 32px;
    }

    .win-cash {
      position: absolute;
      top: 306px;
      right: 38px;
      width: 130px;
      height: 34px;
      font-size: 26px;
      font-family: MiSans, MiSans;
      font-weight: 800;
      text-align: center;
      color: rgba(0, 0, 0, 0.8);
      line-height: 34px;
    }

    .diet-info {
      width: 82.13vw;
      height: 61px;
      position: absolute;
      left: 50%;
      top: 352px;
      transform: translate(-50%, 0%);
      display: flex;
      align-items: center;
      justify-content: space-around;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.8);
      margin-bottom: 12px;

      .diet-bold {
        font-family: DIN-Medium;
        font-size: 20px;
        color: rgba(0, 0, 0, 0.8);
        font-weight: 600;
      }
    }

    .qrcode {
      width: 57px;
      height: 57px;
      object-fit: contain;
      position: absolute;
      bottom: 6px;
      left: 12px;
    }
  }
}
</style>
